import { UserType } from "../../../services/medicationmanagement/medsUser/MedsUserApi";
import { CriticalBadge } from "../../common/status-badge/StatusBadge";

export interface IAllergyStatusProps {
    hasAllergyUpdated: boolean
    userType: UserType;
}

export const AllergyStatusDisplay = (props: IAllergyStatusProps) => {
    if (props.hasAllergyUpdated && props.userType === UserType.Pharmacist) {
        return (
            <CriticalBadge>Allergy update</CriticalBadge>
        );
    } 

    return <></>;
};
